/**
 * SearchIcon – SVG icon.
 */
import Screen from '@screen';

/** Magnifier icon for search actions. */
export default function SearchIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={28 * Screen.widthRatio}
      height={28 * Screen.widthRatio}
      viewBox={'0 0 30 30'}
    >
      <path
        fill='#8e8e93'
        d='M28.229 30a1.781 1.781 0 01-1.282-.549l-8.206-8.21-.008.006a11.513 11.513 0 01-6.9 2.276h-.045a11.807 11.807 0 01-8.38-20.1A11.735 11.735 0 0111.65 0h.05a11.855 11.855 0 0111.786 11.8 11.542 11.542 0 01-2.251 6.926l8.214 8.216A1.771 1.771 0 0128.229 30zM11.665 2.353a9.376 9.376 0 00-6.543 16.032 9.428 9.428 0 006.655 2.783h.036a9.408 9.408 0 00-.106-18.815z'
        data-name='Search'
      />
    </svg>
  );
}
